import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../context/app/appContext';
import axios from 'axios';


export const TopUpsComponent = (props) => {
    const appContext = useContext(AppContext)
    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
    const accessToken = localStorage.getItem('accessToken');
    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ]

    const [topUps, setTopUps] = useState([])


    useEffect(() => {
        (async function getTopUps() {
            const response = await axios.get(baseURL + '/organization/get-topups', {
                headers: {
                    Authorization: 'Bearer ' + accessToken
                }
            });
            console.info({ response })
            if (response.status === 200) {
                // setTopUps(response.data.data.topups.slice(0,3))
                setTopUps(response.data.data.topups)
            }
        })();
    }, [appContext.organization]);


    // const renderTopUps = () => {
    //     return topUps.map(topup => {
    //         var date = new Date(topup.created);
    //         var expected = new Date(topup.expected)
    //         return (
    //             <div key={topup.id} style={{marginTop: 3, marginBottom: 3, backgroundColor: '#f3f3f3', height: 60, display: 'flex', flexDirection: 'row',
    //                 alignSelf: 'center', width: '100%', borderRadius: 5, padding: 5}}>
    //                 <div style={{flex: 4, paddingLeft: 10, alignContent: 'flex-start', display: 'flex', flexDirection: 'column'}}>
    //                     <div style={{flex: 1, flexDirection: 'column', justifyContent: 'flex-end', display: 'flex'}}>
    //                         <span style = {{fontSize: 16, fontFamily: 'SFProText-Medium', color: 'black'}}>${topup.amount}</span>
    //                     </div>
    //                     <div style={{flex: 1, flexDirection: 'column', justifyContent: 'flex-end', display: 'flex'}}>
    //                         <span style={{color: 'rgba(0,0,0,0.5)', fontSize: 10}}>TopUp Date: {monthNames[date.getMonth()].substring(0,3)} {date.getDate()} - {date.getHours() > 12 ? date.getHours()-12 : date.getHours() === 0 ? "12" : date.getHours()}:{date.getMinutes() < 10 ? "0"+date.getMinutes() : date.getMinutes()} {date.getHours() < 12 ? 'AM' : 'PM'}</span>
    //                     </div>
    //                 </div>
    //                 <div style={{flex: 4, paddingRight: 10, alignContent: 'flex-start', display: 'flex', flexDirection: 'column'}}>
    //                     <div style={{flex: 1, flexDirection: 'column', justifyContent: 'center', display: 'flex', alignItems: 'flex-end'}}>
    //                         <span style={{color: topup.status === 'pending' ? 'rgba(0,0,0,0.5)' : 'rgba(0, 207, 143, 1)', fontSize: 14}}>{topup.status.charAt(0).toUpperCase() + topup.status.slice(1)}</span>
    //                     </div>
    //                 </div>
    //             </div>
    //         )
    //     })
    // }



    const renderTopUps = () => {
        return (
            <tbody style={{ borderWidth: 0 }}>
                {topUps.map(topup => {
                    var date = new Date(topup.created);
                    // var expected = new Date(topup.expected)
                    return (
                        <tr key={topup.id} style={{
                            marginTop: 3, marginBottom: 3, backgroundColor: 'white', height: 60,
                            alignSelf: 'center', width: '100%', padding: 5
                        }}>
                            <td style={{ paddingLeft: 10, alignContent: 'flex-start', display: 'flex', flexDirection: 'column', textAlign: 'left', paddingLeft: 20, borderWidth: 1, borderColor: 'rgba(234, 239, 243, 1)' }}>
                                <div style={{}}>
                                    <span style={{ fontSize: 14, fontStyle: 'SFProText-Regular', color: 'rgba(37, 39, 51, 1)' }}>
                                        {monthNames[date.getMonth()].substring(0, 3) + ", " + date.getDate() + ", " + date.getFullYear() + ", "}
                                    </span>
                                    <span style={{ fontSize: 10, fontStyle: 'SFProText-Regular', color: 'rgba(37, 39, 51, 1)', verticalAlign: 'textBottom' }}>
                                        {date.getHours() > 12 ? date.getHours() - 12 : date.getHours() === 0 ? "12" : date.getHours()}:{date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()} {date.getHours() < 12 ? 'AM' : 'PM'}
                                    </span>
                                </div>
                                <div style={{ flex: 1, flexDirection: 'column', justifyContent: 'flex-end', display: 'flex', color: topup.status === 'pending' ? 'rgba(159, 162, 180, 1)' : 'rgba(0, 207, 143, 1)', fontSize: 10, fontStyle: 'SFProText-Medium' }}>
                                    {topup.status.charAt(0).toUpperCase() + topup.status.slice(1)}
                                </div>
                            </td>
                            <td style={{ paddingRight: 10, textAlign: 'center', borderWidth: 1, borderColor: 'rgba(234, 239, 243, 1)' }}>
                                <div style={{ justifyContent: 'center', color: 'rgba(37, 39, 51, 1)', fontSize: 14, fontStyle: 'SFProText-Medium' }}>
                                    {topup.source}
                                </div>
                            </td>
                            <td style={{ paddingRight: 10, textAlign: 'right', paddingRight: 20, borderWidth: 1, borderColor: 'rgba(234, 239, 243, 1)' }}>
                                <div style={{ color: 'rgba(159, 162, 180, 1)', fontSize: 14, fontStyle: 'SFProText-Medium' }}>
                                    ${topup.amount}
                                </div>
                            </td>
                        </tr>
                    )
                })}
            </tbody>
        )
    }

    return (
        <div style={{ paddingTop: 20 }}>
            <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                <span style={{ fontStyle: 'SFProText-Bold', fontSize: 20, color: 'rgba(37, 39, 51, 1)', fontWeight: 'bold' }}>Top Up History</span>
                <span style={{ fontStyle: 'SFProText-Medium', fontSize: 10, color: 'rgba(159, 162, 180, 1)', paddingLeft: 10 }}>(Last 3)</span>
                <span style={{ fontStyle: 'SFProText-Bold', fontSize: 14, color: 'rgba(55, 81, 255, 1)', float: 'right' }}>View Details</span>
            </div>
            <table className="ui single line table" style={{ backgroundColor: 'transparent', borderWidth: 0 }}>
                <thead style={{ backgroundColor: 'transparent' }}>
                    <tr style={{ backgroundColor: 'transparent', height: 55 }}>
                        <th style={{ color: 'rgba(37, 39, 51, 1)', fontSize: 14, fontStyle: 'SFProText-Bold', backgroundColor: 'transparent', textAlign: 'left', paddingLeft: 20, borderWidth: 1, borderColor: 'rgba(159, 162, 180, 1)' }}>Date Avaliable</th>
                        <th style={{ color: 'rgba(37, 39, 51, 1)', fontSize: 14, fontStyle: 'SFProText-Bold', backgroundColor: 'transparent', textAlign: 'center', borderWidth: 1, borderColor: 'rgba(159, 162, 180, 1)' }}>Source</th>
                        <th style={{ color: 'rgba(159, 162, 180, 1)', fontSize: 14, fontStyle: 'SFProText-Bold', backgroundColor: 'transparent', textAlign: 'right', paddingRight: 20, borderWidth: 1, borderColor: 'rgba(159, 162, 180, 1)' }}>Amount (USD)</th>
                    </tr>
                </thead>
                {renderTopUps()}
            </table>
        </div>

    )
}